import React from 'react';
import { Skeleton } from '@oneaudi/unified-web-components';
import {
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_150,
  SYS_SPACE_FIXED_200,
  SYS_SPACE_FIXED_350,
  SYS_SPACE_FIXED_50,
  SYS_SPACE_FIXED_500,
  SYS_SPACE_RELATIVE_2_XL,
  SYS_SPACE_RELATIVE_MD,
} from '@oneaudi/unified-web-common';
import styled from 'styled-components';

interface Props {}
const TagContainer = styled.div`
  display: flex;
  max-height: 68px;
  align-items: flex-start;
  align-content: flex-start;
  gap: ${SYS_SPACE_FIXED_150};
  align-self: stretch;
  flex-wrap: wrap;
  margin-left: ${SYS_SPACE_FIXED_200};
`;
const CTAContainer = styled.div`
  display: flex;
  margin-left: ${SYS_SPACE_FIXED_200};
  margin-bottom: ${SYS_SPACE_FIXED_200};
`;
const TileContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${SYS_SPACE_RELATIVE_2_XL};
  margin-bottom: ${SYS_SPACE_RELATIVE_MD};
`;

export const TileSkeleton: React.FC<Props> = () => {
  return (
    <TileContainer>
      {/* Image */}
      <Skeleton
        variant="rectangular"
        width="100%"
        aspectRatio="4/3"
        margin={[0, 0, SYS_SPACE_FIXED_500, 0]}
      />
      {/* Car Name */}
      <Skeleton
        variant="rectangular"
        width="150px"
        height="32px"
        margin={[0, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_350, SYS_SPACE_FIXED_200]}
      />
      {/* Price Label */}
      <Skeleton
        variant="rectangular"
        width="150px"
        height="16px"
        margin={[0, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_200]}
      />
      {/* Price */}
      <Skeleton
        variant="rectangular"
        width="230px"
        height="32px"
        margin={[0, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_200]}
      />
      {/* Price Disclaimer */}
      <Skeleton
        variant="rectangular"
        width="230px"
        height="16px"
        margin={[0, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_350, SYS_SPACE_FIXED_200]}
      />
      {/* Two Rows of Tags */}
      <TagContainer>
        <Skeleton variant="rectangular" width="96px" height="28px" />
        <Skeleton variant="rectangular" width="96px" height="28px" />
      </TagContainer>
      <TagContainer>
        <Skeleton
          variant="rectangular"
          width="96px"
          height="28px"
          margin={[SYS_SPACE_FIXED_150, 0, 0, 0]}
        />
        <Skeleton
          variant="rectangular"
          width="96px"
          height="28px"
          margin={[SYS_SPACE_FIXED_150, 0, 0, 0]}
        />
      </TagContainer>
      {/* Available Label */}
      <Skeleton
        variant="rectangular"
        width="230px"
        height="16px"
        margin={[SYS_SPACE_FIXED_350, 0, SYS_SPACE_FIXED_350, SYS_SPACE_FIXED_200]}
      />
      {/* CTAs */}
      <CTAContainer>
        <Skeleton
          variant="rectangular"
          width="204px"
          height="48px"
          margin={[0, SYS_SPACE_FIXED_50, 0, 0]}
        />
        <Skeleton variant="rectangular" width="48px" height="48px" />
      </CTAContainer>
      {/* C&E Label */}
      <Skeleton
        variant="rectangular"
        width="230px"
        height="16px"
        margin={[0, 0, '8px', SYS_SPACE_FIXED_200]}
      />
      {/* C&E Link */}
      <Skeleton
        variant="rectangular"
        width="150px"
        height="16px"
        margin={[0, 0, 0, SYS_SPACE_FIXED_200]}
      />
    </TileContainer>
  );
};
